export function GameChangerLogo({ className = '' }: { className?: string }) {
  return (
    <svg
      width="263"
      height="29"
      viewBox="0 0 263 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.5">
        <path
          d="M12.5723 27.7391C10.7557 27.7391 9.08315 27.4307 7.55468 26.8139C6.0262 26.1847 4.69818 25.2718 3.57062 24.0751C2.44305 22.8785 1.56606 21.4227 0.939636 19.7079C0.313212 17.9931 0 16.0439 0 13.8603C0 10.9859 0.532461 8.51851 1.59738 6.45828C2.6623 4.38571 4.14066 2.79427 6.03247 1.68396C7.92427 0.561322 10.1042 0 12.5723 0C15.7546 0 18.2916 0.727867 20.1834 2.1836C22.0877 3.63934 23.3844 5.65022 24.0735 8.21626L20.0894 8.91946C19.5382 7.32802 18.6486 6.05733 17.4209 5.10741C16.1931 4.15748 14.6521 3.67635 12.7978 3.66401C10.881 3.65167 9.28361 4.07112 8.0057 4.92236C6.74033 5.77359 5.78816 6.97025 5.14921 8.51234C4.51025 10.0421 4.18451 11.8248 4.17199 13.8603C4.15946 15.8959 4.47267 17.6785 5.11162 19.2083C5.75057 20.7257 6.709 21.91 7.98691 22.7613C9.27734 23.6125 10.881 24.0443 12.7978 24.0566C14.3389 24.0813 15.6606 23.8037 16.7631 23.2239C17.8781 22.6317 18.7614 21.7682 19.4129 20.6332C20.0644 19.4982 20.4841 18.1042 20.672 16.451H15.41V13.3422H24.844C24.869 13.5642 24.8878 13.8603 24.9004 14.2304C24.9129 14.5882 24.9192 14.8164 24.9192 14.9151C24.9192 17.3825 24.4368 19.5846 23.4721 21.5214C22.5074 23.4583 21.1042 24.9819 19.2625 26.0922C17.4209 27.1901 15.1908 27.7391 12.5723 27.7391Z"
          fill="url(#paint0_linear_315_26702)"
        />
        <path
          d="M26.0514 27.184L34.8464 0.536649L40.503 0.536649L49.298 27.184H45.22L37.1203 2.86829H38.1351L30.1294 27.184H26.0514ZM30.618 21.1698V17.5428H44.7502V21.1698H30.618Z"
          fill="url(#paint1_linear_315_26702)"
        />
        <path
          d="M52.6696 27.184V0.536649L56.2214 0.536649L66.0312 20.5777L75.7846 0.536649H79.374V27.1655L75.6531 27.1655V8.93796L66.9144 27.184H65.1291L56.3717 8.93796V27.184H52.6696Z"
          fill="url(#paint2_linear_315_26702)"
        />
        <path
          d="M84.6392 27.184V0.536649L101.929 0.536649V4.18215L88.5669 4.18215V11.6582H99.6734V15.3037H88.5669V23.5385H101.929V27.184H84.6392Z"
          fill="url(#paint3_linear_315_26702)"
        />
        <path
          d="M118.386 29C115.704 29 113.419 28.3942 111.532 27.1827C109.645 25.9582 108.199 24.2569 107.193 22.0787C106.2 19.9004 105.703 17.3742 105.703 14.5C105.703 11.6258 106.2 9.09956 107.193 6.92133C108.199 4.74311 109.645 3.04822 111.532 1.83667C113.419 0.612222 115.704 0 118.386 0C121.477 0 124.035 0.812 126.059 2.436C128.095 4.06 129.51 6.24467 130.305 8.99L126.357 10.092C125.835 8.14578 124.904 6.61844 123.563 5.51C122.235 4.40156 120.509 3.84733 118.386 3.84733C116.486 3.84733 114.903 4.292 113.637 5.18133C112.37 6.07067 111.414 7.31445 110.769 8.91267C110.136 10.5109 109.819 12.3733 109.819 14.5C109.807 16.6267 110.117 18.4891 110.75 20.0873C111.396 21.6856 112.352 22.9293 113.618 23.8187C114.897 24.708 116.486 25.1527 118.386 25.1527C120.509 25.1527 122.235 24.5984 123.563 23.49C124.904 22.3687 125.835 20.8413 126.357 18.908L130.305 20.01C129.51 22.7553 128.095 24.94 126.059 26.564C124.035 28.188 121.477 29 118.386 29Z"
          fill="url(#paint4_linear_315_26702)"
        />
        <path
          d="M118.386 29C115.704 29 113.419 28.3942 111.532 27.1827C109.645 25.9582 108.199 24.2569 107.193 22.0787C106.2 19.9004 105.703 17.3742 105.703 14.5C105.703 11.6258 106.2 9.09956 107.193 6.92133C108.199 4.74311 109.645 3.04822 111.532 1.83667C113.419 0.612222 115.704 0 118.386 0C121.477 0 124.035 0.812 126.059 2.436C128.095 4.06 129.51 6.24467 130.305 8.99L126.357 10.092C125.835 8.14578 124.904 6.61844 123.563 5.51C122.235 4.40156 120.509 3.84733 118.386 3.84733C116.486 3.84733 114.903 4.292 113.637 5.18133C112.37 6.07067 111.414 7.31445 110.769 8.91267C110.136 10.5109 109.819 12.3733 109.819 14.5C109.807 16.6267 110.117 18.4891 110.75 20.0873C111.396 21.6856 112.352 22.9293 113.618 23.8187C114.897 24.708 116.486 25.1527 118.386 25.1527C120.509 25.1527 122.235 24.5984 123.563 23.49C124.904 22.3687 125.835 20.8413 126.357 18.908L130.305 20.01C129.51 22.7553 128.095 24.94 126.059 26.564C124.035 28.188 121.477 29 118.386 29Z"
          fill="url(#paint5_linear_315_26702)"
        />
        <path
          d="M141.668 28.42L150.384 0.58L155.99 0.58L164.706 28.42H160.664L152.638 3.016H153.643L145.71 28.42H141.668ZM146.194 22.1367V18.3473H160.199V22.1367H146.194Z"
          fill="url(#paint6_linear_315_26702)"
        />
        <path
          d="M141.668 28.42L150.384 0.58L155.99 0.58L164.706 28.42H160.664L152.638 3.016H153.643L145.71 28.42H141.668ZM146.194 22.1367V18.3473H160.199V22.1367H146.194Z"
          fill="url(#paint7_linear_315_26702)"
        />
        <path
          d="M168.047 28.42V0.58L171.995 0.58L185.199 21.2667V0.58H189.147V28.42H185.199L171.995 7.714V28.42H168.047Z"
          fill="url(#paint8_linear_315_26702)"
        />
        <path
          d="M168.047 28.42V0.58L171.995 0.58L185.199 21.2667V0.58H189.147V28.42H185.199L171.995 7.714V28.42H168.047Z"
          fill="url(#paint9_linear_315_26702)"
        />
        <path
          d="M205.314 29C203.514 29 201.857 28.6778 200.342 28.0333C198.827 27.376 197.511 26.4222 196.394 25.172C195.276 23.9218 194.407 22.4009 193.786 20.6093C193.166 18.8178 192.855 16.7813 192.855 14.5C192.855 11.4969 193.383 8.91911 194.438 6.76667C195.494 4.60133 196.959 2.93867 198.833 1.77867C200.708 0.605777 202.869 0.0193319 205.314 0.0193319C208.468 0.0193319 210.982 0.779777 212.857 2.30067C214.744 3.82156 216.029 5.92244 216.712 8.60333L212.764 9.338C212.218 7.67533 211.336 6.34778 210.119 5.35533C208.903 4.36289 207.375 3.86022 205.538 3.84733C203.638 3.83444 202.055 4.27267 200.789 5.162C199.535 6.05133 198.591 7.30156 197.958 8.91267C197.325 10.5109 197.002 12.3733 196.99 14.5C196.977 16.6267 197.288 18.4891 197.921 20.0873C198.554 21.6727 199.504 22.91 200.77 23.7993C202.049 24.6887 203.638 25.1398 205.538 25.1527C207.065 25.1784 208.375 24.8884 209.467 24.2827C210.572 23.664 211.448 22.7618 212.093 21.576C212.739 20.3902 213.155 18.9338 213.341 17.2067H208.127V13.9587H217.476C217.5 14.1907 217.519 14.5 217.531 14.8867C217.544 15.2604 217.55 15.4989 217.55 15.602C217.55 18.1798 217.072 20.4804 216.116 22.504C215.16 24.5276 213.77 26.1193 211.944 27.2793C210.119 28.4264 207.909 29 205.314 29Z"
          fill="url(#paint10_linear_315_26702)"
        />
        <path
          d="M205.314 29C203.514 29 201.857 28.6778 200.342 28.0333C198.827 27.376 197.511 26.4222 196.394 25.172C195.276 23.9218 194.407 22.4009 193.786 20.6093C193.166 18.8178 192.855 16.7813 192.855 14.5C192.855 11.4969 193.383 8.91911 194.438 6.76667C195.494 4.60133 196.959 2.93867 198.833 1.77867C200.708 0.605777 202.869 0.0193319 205.314 0.0193319C208.468 0.0193319 210.982 0.779777 212.857 2.30067C214.744 3.82156 216.029 5.92244 216.712 8.60333L212.764 9.338C212.218 7.67533 211.336 6.34778 210.119 5.35533C208.903 4.36289 207.375 3.86022 205.538 3.84733C203.638 3.83444 202.055 4.27267 200.789 5.162C199.535 6.05133 198.591 7.30156 197.958 8.91267C197.325 10.5109 197.002 12.3733 196.99 14.5C196.977 16.6267 197.288 18.4891 197.921 20.0873C198.554 21.6727 199.504 22.91 200.77 23.7993C202.049 24.6887 203.638 25.1398 205.538 25.1527C207.065 25.1784 208.375 24.8884 209.467 24.2827C210.572 23.664 211.448 22.7618 212.093 21.576C212.739 20.3902 213.155 18.9338 213.341 17.2067H208.127V13.9587H217.476C217.5 14.1907 217.519 14.5 217.531 14.8867C217.544 15.2604 217.55 15.4989 217.55 15.602C217.55 18.1798 217.072 20.4804 216.116 22.504C215.16 24.5276 213.77 26.1193 211.944 27.2793C210.119 28.4264 207.909 29 205.314 29Z"
          fill="url(#paint11_linear_315_26702)"
        />
        <path
          d="M221.262 28.42V0.58L238.396 0.58V4.38867H225.154V12.1993H236.161V16.008H225.154V24.6113H238.396V28.42H221.262Z"
          fill="url(#paint12_linear_315_26702)"
        />
        <path
          d="M221.262 28.42V0.58L238.396 0.58V4.38867H225.154V12.1993H236.161V16.008H225.154V24.6113H238.396V28.42H221.262Z"
          fill="url(#paint13_linear_315_26702)"
        />
        <path
          d="M242.868 28.42V0.58L253.707 0.58C253.968 0.58 254.291 0.592888 254.675 0.618666C255.06 0.631555 255.427 0.670222 255.774 0.734667C257.264 0.979555 258.506 1.508 259.499 2.32C260.505 3.132 261.256 4.15667 261.752 5.394C262.249 6.63133 262.497 7.99756 262.497 9.49267C262.497 11.7096 261.951 13.6236 260.859 15.2347C259.766 16.8329 258.127 17.8318 255.942 18.2313L254.359 18.4247H246.761V28.42H242.868ZM258.549 28.42L253.26 17.0907L257.19 16.0467L263 28.42H258.549ZM246.761 14.5967H253.558C253.806 14.5967 254.08 14.5838 254.378 14.558C254.688 14.5322 254.98 14.4871 255.253 14.4227C256.047 14.2293 256.687 13.8749 257.171 13.3593C257.655 12.8309 258.003 12.2251 258.214 11.542C258.425 10.8589 258.531 10.1758 258.531 9.49267C258.531 8.80956 258.425 8.13289 258.214 7.46267C258.003 6.77955 257.655 6.18022 257.171 5.66467C256.687 5.13622 256.047 4.77533 255.253 4.582C254.98 4.50467 254.688 4.45311 254.378 4.42733C254.08 4.40156 253.806 4.38867 253.558 4.38867H246.761V14.5967Z"
          fill="url(#paint14_linear_315_26702)"
        />
        <path
          d="M242.868 28.42V0.58L253.707 0.58C253.968 0.58 254.291 0.592888 254.675 0.618666C255.06 0.631555 255.427 0.670222 255.774 0.734667C257.264 0.979555 258.506 1.508 259.499 2.32C260.505 3.132 261.256 4.15667 261.752 5.394C262.249 6.63133 262.497 7.99756 262.497 9.49267C262.497 11.7096 261.951 13.6236 260.859 15.2347C259.766 16.8329 258.127 17.8318 255.942 18.2313L254.359 18.4247H246.761V28.42H242.868ZM258.549 28.42L253.26 17.0907L257.19 16.0467L263 28.42H258.549ZM246.761 14.5967H253.558C253.806 14.5967 254.08 14.5838 254.378 14.558C254.688 14.5322 254.98 14.4871 255.253 14.4227C256.047 14.2293 256.687 13.8749 257.171 13.3593C257.655 12.8309 258.003 12.2251 258.214 11.542C258.425 10.8589 258.531 10.1758 258.531 9.49267C258.531 8.80956 258.425 8.13289 258.214 7.46267C258.003 6.77955 257.655 6.18022 257.171 5.66467C256.687 5.13622 256.047 4.77533 255.253 4.582C254.98 4.50467 254.688 4.45311 254.378 4.42733C254.08 4.40156 253.806 4.38867 253.558 4.38867H246.761V14.5967Z"
          fill="url(#paint15_linear_315_26702)"
        />
        <path
          d="M120.979 14.4903C120.979 13.4386 121.832 12.586 122.883 12.586H134.388V0.58C136.548 0.58 138.299 2.33099 138.299 4.49094V28.42C136.139 28.42 134.388 26.669 134.388 24.5091V16.3947H122.883C121.832 16.3947 120.979 15.5421 120.979 14.4903Z"
          fill="url(#paint16_linear_315_26702)"
        />
        <path
          d="M120.979 14.4903C120.979 13.4386 121.832 12.586 122.883 12.586H134.388V0.58C136.548 0.58 138.299 2.33099 138.299 4.49094V28.42C136.139 28.42 134.388 26.669 134.388 24.5091V16.3947H122.883C121.832 16.3947 120.979 15.5421 120.979 14.4903Z"
          fill="url(#paint17_linear_315_26702)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_315_26702"
          x1="-9.79288e-09"
          y1="14.5"
          x2="262.999"
          y2="14.7075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_315_26702"
          x1="-9.79288e-09"
          y1="14.5"
          x2="262.999"
          y2="14.7075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_315_26702"
          x1="-9.79288e-09"
          y1="14.5"
          x2="262.999"
          y2="14.7075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_315_26702"
          x1="-9.79288e-09"
          y1="14.5"
          x2="262.999"
          y2="14.7075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4B4" />
          <stop offset="1" stopColor="#4E4E4E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4B4" />
          <stop offset="1" stopColor="#4E4E4E" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4B4" />
          <stop offset="1" stopColor="#4E4E4E" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4B4" />
          <stop offset="1" stopColor="#4E4E4E" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4B4" />
          <stop offset="1" stopColor="#4E4E4E" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4B4" />
          <stop offset="1" stopColor="#4E4E4E" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4B4" />
          <stop offset="1" stopColor="#4E4E4E" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_315_26702"
          x1="-1.32116"
          y1="14.5"
          x2="263"
          y2="14.8078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3C57A" />
          <stop offset="1" stopColor="#5BA1A1" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GameChangerLogo;
